import gql from "graphql-tag";

import { VALUE_LIST_FRAGMENT } from "./valuelist-gql";

const POSITION_FRAGMENT =  gql`
    ${VALUE_LIST_FRAGMENT}
    fragment positionFragment on Position {
        positionId
        positionName
        fullPositionName
        positionNameFMSync
        positionNameFM
        positionNameFFSync
        positionNameFF
        positionTitle{
            positionTitleId
            positionName
        }
        positionPrefix
	    positionSuffix
        positionSeparator{
            ...valueListFragment
        }
        positionPortfolio
        positionHonorificId
        bilingualIndicator
        managementIndicator
        isRole
        restricted
        shareLinkId
        clonedFromId
        sharedToIds
        orgId
        childId
        individuals{
            positionAssignmentId
            positionId
            positionName
            individualId
            firstName
            middleName
            lastName
            indStatus
            indStatusReason{
                ...valueListFragment
            }
            assignmentType
            restricted
            startDate
            acting
            x509
            relType{
                ...valueListFragment
            }
            gender{
                ...valueListFragment
            }
            honorific{
                ...valueListFragment
            }
        }
    }
`
export const GET_ORG_POSITIONS =gql`
    ${POSITION_FRAGMENT}
    query PositionsByOrgId($orgId: ID!) {
        org(orgId: $orgId) {
            id
            positions {
                ...positionFragment
            }
        }
    }
`;

export const GET_ORG_ROLES = gql`
    ${POSITION_FRAGMENT}
    query RolesByOrgId($orgId: ID!) {
        org(orgId: $orgId) {
            id
            roles {
                ...positionFragment
            }
        }
    }
`;

export const UPDATE_POSITION = gql`
${POSITION_FRAGMENT}
mutation UpdatePosition($positionId: ID!, $input: PositionInput!) {
    updatePosition(positionId: $positionId, input: $input) {
        ...positionFragment
    }
}
`;

export const CREATE_POSITION_ROLE = gql`
${POSITION_FRAGMENT}
mutation CreatePositionOrRole($orgId: ID!, $relTypeId:ID!, $isRole:Boolean!, $input: PositionInput!) {
    createPositionOrRole(orgId: $orgId, relTypeId:$relTypeId, isRole:$isRole , input: $input) {
        ...positionFragment
    }
}
`;

export const EXPIRE_POSITION_ROLE = gql`
mutation ExpirePositionOrRole($orgId:ID!,$positionIds:[ID!]){
    expirePositionOrRole(orgId:$orgId,positionIds:$positionIds){
        success
        code
        message
    }
}
`;
export const GET_POSITION_DETAIL = gql`
    ${POSITION_FRAGMENT}
    query Postion($positionId:ID!){
        position(positionId:$positionId){
          ...positionFragment
        }
    }
`;

export const GET_POSITION_ASSIGNMENT = gql`
    ${VALUE_LIST_FRAGMENT}
    query Postion($positionId:ID!){
        position(positionId:$positionId){
          individuals{
            positionAssignmentId
            positionId
            positionName
            individualId
            firstName
            middleName
            lastName
            indStatus
            indStatusReason{
                ...valueListFragment
            }
            assignmentType
            restricted
            startDate
            acting
            x509
            relType{
                ...valueListFragment
            }
            gender{
                ...valueListFragment
            }
            honorific{
                ...valueListFragment
            }
          }
        }
    }
`;

export const POSITION_TITLES = gql`
    query PositionTitles($input:String!,$limit:Int,$categoryId:ID!){
        positionTitles(q:$input,limit:$limit,categoryId:$categoryId){
            positionTitleId
            positionName
        }
    }`;

export const INDIVIDUAL_POSITIONS = gql`
    query IndividualPositions($individualId: ID!) {
        individualPositions(individualId: $individualId) {
            positionId
            positionName
            firstName
            middleName
            lastName
            relType{
                code
            }
            indStatus
        }
    }
`;

export const GET_ROLE_DETAIL = gql`
    ${POSITION_FRAGMENT}
    query Role($roleId:ID!){
        role(roleId:$roleId){
          ...positionFragment
        }
    }
`;

export const UPDATE_ROLE = gql`
${POSITION_FRAGMENT}
mutation UpdateRole($roleId: ID!, $input: PositionInput!) {
    updateRole(roleId: $roleId, input: $input) {
        ...positionFragment
    }
}
`;

export const GET_ORG_PATH_BY_POSITION = gql `
    query OrgPathByPosition($positionId:ID!){
        orgPathByPosition(positionId:$positionId)
    }
`;

export const GET_ORG_BY_POSITION = gql`
  query OrgByPosition($positionId:ID!) {
    orgByPosition(positionId:$positionId) {
      id
      name
    }
  }
`;

export const GET_ORGS_BY_POSITIONS = gql `
    query OrgsByPositions($positionIds:[ID]){
        orgsByPositions(positionIds:$positionIds)
    }
`;

export const REMOVE_ACTING_LINK = gql`
    mutation removeActingLink($positionId:ID!,$positionAssignmentIds: [ID!]) {
        removeActingLink(positionId:$positionId,positionAssignmentIds: $positionAssignmentIds)
    }
`;

export const MOVE_POSITION_ROLE = gql`
    mutation MovePositionOrRole($action:Action!,$sourceOrgId:ID!, $destOrgId:ID!,$positionIds:[ID]!){
        movePostionOrRole(action:$action,sourceOrgId:$sourceOrgId,destOrgId:$destOrgId,positionIds:$positionIds){
        action
        success
        code
        message
        }
    }
`;

export const POSITIONS_BY_NAME_AND_CATEGORY = gql`
    query PositionsByNameAndCategory($input: SearchPositionTitlesInput!){
        positionsByNameAndCategory(input:$input){
            positionTitleId
            positionName
            categoryId
            status
        }
    }
`;

export const SEARCH_POSITION = gql`
query SearchPosition($input:SearchPositionInput!){
    searchPosition(input:$input){
        message
        positions{
          positionId
          assignmentType
          title
          restricted
          individualId
          individualFirstName
          individualMiddleName
          individualLastName
          phoneFaxes{
            id
            countryCode
            areaCode
            localNumber
            extension
            presentationSeq
          }
          emails{
            id
            emailAddressTxt
            presentationSeq
            assignType{
                id
                code
                label
                label2
            }
          }
          role
          orgId
          active
        }
      }
  }
`;
export const MEMBERSHIP_TITLES_BY_CATEGORYNAME = gql`
    query membershipTitlesByCategoryName($categoryName: String){
        membershipTitlesByCategoryName(categoryName:$categoryName){
            positionTitleId
            positionName
            status
            categoryId
        }
    }
`;

export const HAS_MANAGEMENT = gql`
    query HasManagement($positionId:ID!){
        hasManagement(positionId: $positionId)
    }
`;

export const CREATE_POSITION_TITLE = gql`
    mutation CreatePositionTitle($input: PositionTitleInput!) {
        createPositionTitle(input: $input) {
            positionTitleId
            positionName
            status
            categoryId
        }
    }
`;

export const UPDATE_POSITION_TITLE = gql`
    mutation UpdatePositionTitle($positionTitleId: ID!, $input: PositionTitleInput!) {
        updatePositionTitle(positionTitleId: $positionTitleId, input: $input) {
            positionTitleId
            positionName
            status
            categoryId
        }
    }

`;

export const TOTAL_POSITIONS_BY_POSITION_TITLE = gql`
    query TotalPositionsByPositionTitle($positionTitleId:ID!){
        totalPositionsByPositionTitle(positionTitleId:$positionTitleId)
    }
`;

export const FULL_POSITION_NAME =
gql`
query FullPositionName($positionId:ID!){
    fullPositionName(positionId:$positionId)
}
`;
